/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { DiscoveryRuleMatch } from "~/generated/graphql";
import { DiscoveryRuleMatchKeys } from "../types";

export function mergeMatches(
  match: DiscoveryRuleMatch,
  newMatch: DiscoveryRuleMatch
): DiscoveryRuleMatch {
  return Object.entries(newMatch).reduce((acc, [key, value]) => {
    return {
      ...acc,
      // @ts-expect-error Generated types are not accurate for this case
      [key]: [...(acc[key as DiscoveryRuleMatchKeys] ?? []), ...value],
    };
  }, match);
}
